import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { track } from "@/lib/analytics";

/** Records one page_view per route change (first-party analytics). */
export default function AnalyticsTracker() {
  const location = useLocation();
  const last = useRef<string>("");

  useEffect(() => {
    const key = location.pathname + location.search;
    if (last.current === key) return;
    last.current = key;
    track("page_view");
  }, [location.pathname, location.search]);

  return null;
}
